export default function Placeholder({ label = "Image", className = "" }) {
  return (
    <div
      className={`relative flex items-center justify-center bg-muted overflow-hidden ${className}`}
      role="img"
      aria-label={label}
    >
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: "radial-gradient(hsl(var(--border)) 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />
      <span className="relative font-serif italic text-muted-foreground/70 text-lg sm:text-xl px-6 text-center">
        {label}
      </span>
    </div>
  );
}
